import React, { useState } from 'react';
import styled from 'styled-components';

// Garde côté client, activée uniquement si REACT_APP_SESSION_PASSWORD est défini
// au build (préprod). Absente en prod/local → l'app s'affiche directement.
// Note : garde d'obfuscation (le mot de passe finit dans le bundle) — tient les
// curieux à l'écart d'une préprod publique, pas un mur de sécurité.
const SESSION_PASSWORD = process.env.REACT_APP_SESSION_PASSWORD;
const STORAGE_KEY = 'bo_session_unlocked';

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: #0c1635;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;

const Card = styled.div`
    background: #ffffff;
    border-radius: 12px;
    padding: 40px 36px;
    width: 320px;
    max-width: 90vw;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    text-align: center;
`;

const Title = styled.h2`
    margin: 0 0 6px;
    color: #0c1635;
    font-size: 20px;
`;

const Sub = styled.p`
    margin: 0 0 24px;
    color: #6b7280;
    font-size: 13px;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 15px;
    box-sizing: border-box;
    &:focus {
        outline: none;
        border-color: #0c1635;
    }
`;

const ErrorMsg = styled.div`
    color: #dc2626;
    font-size: 13px;
    margin-top: 8px;
`;

const Button = styled.button`
    width: 100%;
    margin-top: 16px;
    padding: 12px;
    background: #0c1635;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    &:hover {
        opacity: 0.9;
    }
`;

export const SessionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [unlocked, setUnlocked] = useState<boolean>(() => sessionStorage.getItem(STORAGE_KEY) === '1');
    const [value, setValue] = useState('');
    const [error, setError] = useState(false);

    // Pas de mot de passe configuré (prod/local) ou déjà déverrouillé → app directe
    if (!SESSION_PASSWORD || unlocked) {
        return <>{children}</>;
    }

    const submit = (e: React.FormEvent) => {
        e.preventDefault();
        if (value === SESSION_PASSWORD) {
            sessionStorage.setItem(STORAGE_KEY, '1');
            setUnlocked(true);
        } else {
            setError(true);
        }
    };

    return (
        <Overlay>
            <Card>
                <Title>Accès restreint</Title>
                <Sub>Environnement de préproduction</Sub>
                <form onSubmit={submit}>
                    <Input
                        type="password"
                        autoFocus
                        value={value}
                        onChange={e => {
                            setValue(e.target.value);
                            setError(false);
                        }}
                        placeholder="Mot de passe"
                    />
                    {error && <ErrorMsg>Mot de passe incorrect</ErrorMsg>}
                    <Button type="submit">Entrer</Button>
                </form>
            </Card>
        </Overlay>
    );
};

export default SessionGate;
